export default __webpack_public_path__ + "static/media/icon-copy.c8591eb8.svg";